// extracted by mini-css-extract-plugin
export default {"notif":"notif_notif__5Rpbl"};